import type { FindingStatus } from '../api/types';
import { statusMeta } from '../lib/format';

export function StatusBadge({ status, needsReview = false }: { status: FindingStatus; needsReview?: boolean }) {
  const meta = statusMeta[status];
  return (
    <span className="status-group">
      <span className={`status status--${status}`} title={meta.description}>
        <span aria-hidden="true" className="status__symbol">
          {meta.symbol}
        </span>
        {meta.label}
      </span>
      {needsReview && (
        <span className="status status--flag" title="Source material changed or a correction arrived after this version.">
          <span aria-hidden="true" className="status__symbol">
            !
          </span>
          Needs review
        </span>
      )}
    </span>
  );
}

export function StatusLegend() {
  return (
    <dl className="status-legend">
      {(Object.keys(statusMeta) as FindingStatus[]).map((status) => (
        <div key={status} className="status-legend__item">
          <dt>
            <StatusBadge status={status} />
          </dt>
          <dd>{statusMeta[status].description}</dd>
        </div>
      ))}
    </dl>
  );
}
